/*
   Copyright 2022 Nikita Petko <petko@vmminfra.net>

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/

/*
	File Name: trip_reason_authority_base.ts
	Description: Base class for trip reason authorities.
	Written by: Nikita Petko
*/

import ITripReasonAuthority from '../interfaces/trip_reason_authority';

/**
 * Base class for trip reason authorities.
 * @template TExecutionContext The type of the execution context.
 */
export default abstract class TripReasonAuthorityBase<TExecutionContext>
  implements ITripReasonAuthority<TExecutionContext>
{
  /**
   * Is a reason for tripping the circuit breaker.
   * @param {TExecutionContext} executionContext The execution context.
   * @param {Error} error The error that occurred.
   * @returns {boolean} True if the error is a reason for tripping the circuit breaker, otherwise false.
   */
  public abstract isReasonForTrip(executionContext: TExecutionContext, error: Error): boolean;
}
